<template lang="html">
  <div class="df-profile">
    <div class="tabs">
      <el-tabs v-model="activeName">
        <el-tab-pane label="基本信息" name="first">
          <h3>基本信息</h3>
          <div class="base">
            <div class="row">
              <div class="left">联系人</div>
              <div class="right">{{userProfile.contacts}}</div>
            </div>
            <div class="row">
              <div class="left">联系电话</div>
              <div class="right">{{userProfile.mobile}}</div>
            </div>
            <div class="row">
              <div class="left">账户余额</div>
              <div class="right">{{userProfile.account}}</div>
            </div>
            <div class="row">
              <div class="left">地址</div>
              <div class="right">{{userProfile.address}}</div>
            </div>
            <div class="row">
              <div class="left">营业执照</div>
              <div class="right">
                <img :src="user_expand.business_license" class="business_license" />
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="收款账户管理" name="second">
          <div class="base">
            <div class="row">
              <div class="left">银行名称</div>
              <div class="right">{{user_expand.bank_name}}</div>
            </div>
            <div class="row">
              <div class="left">开户银行支行</div>
              <div class="right">{{user_expand.sub_branch}}</div>
            </div>
            <div class="row">
              <div class="left">银行卡号</div>
              <div class="right">{{user_expand.bank_account}}</div>
            </div>
            <div class="row">
              <div class="left">银行开户名</div>
              <div class="right">{{user_expand.bank_user_name}}</div>
            </div>
            <div class="row">
              <div class="left">开户银行身份证</div>
              <div class="right">{{user_expand.id_code}}</div>
            </div>
            <div class="row">
              <div class="left">银行预留手机号</div>
              <div class="right">{{user_expand.bank_user_phone}}</div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>  
    </div>
  </div>
</template>

<script>
import api from '@/api'

import {
  mapGetters,
  mapActions,
  mapMutations
} from 'vuex'
export default {
  name: 'userProfile',
  data() {
    return {
      userProfile: {},  // 个人信息 or 用户信息
      activeName: 'first',
      user_expand:{}
    }
  },
  computed: {
    ...mapGetters([
      'isLogined',
      'profile'
    ])
  },
  created() {
    // 加载用户数据
    this.loadUserProfile(this.$router.currentRoute.path)
  },
  watch: {
    // 用户信息页面 和 个人信息页面 复用同一组件，而原来的组件实例会被复用，所以生命周期钩子不会再被调用
    // 因此需要侦听路由变化，来加载数据
    '$route' (to, from) {
      this.loadUserProfile(to.path)
    }
  },
  methods: {

    // 加载个人信息
    async loadUserProfile(path) {
      await this.loadProfile()
      this.userProfile = this.profile
      this.user_expand = this.profile.user_expand
    },
    ...mapMutations([
      'TOGGLE_LOADING_STATUS'
    ]),
    ...mapActions([
      'loadProfile',
    ])
  }

}
</script>
<style lang="stylus" scoped>
@import '../../common/stylus/common'

.tabs
  margin-top 20px
  .base
    border 1px solid rgb(230,230,230)
    .row
      line-height 28px
      display flex
      border-bottom 1px solid rgb(230,230,230)
      .left
        display flex
        align-items center
        padding 9px 30px
        width 180px 
        border-right 1px solid rgb(230,230,230)
      .right
        display flex
        align-items center
        padding 9px 30px
        width 180px
        .business_license
          width 200px
          height 200px
 
</style>



// WEBPACK FOOTER //
// Profile.vue?09f13f93